module.exports = __webpack_public_path__ + "img/horse-ride--icon--gray.a2b84b6c.svg";